import canon from "/assets/images/canon.png";

export const canonImg = canon;

import hmv from "/assets/videos/canon.mp4";
import smallmv from "/assets/videos/smallCanon.mp4";
import highlightFirstmv from "/assets/videos/highlight-first.mp4";
import highlightSectmv from "/assets/videos/hightlight-third.mp4";
import highlightThirdmv from "/assets/videos/hightlight-sec.mp4";
import highlightFourthmv from "/assets/videos/hightlight-fourth.mp4";
import highlightFifthmv from "/assets/videos/hightlight-fifth.mp4";
import highlightSixthmv from "/assets/videos/hightlight-sixth.mp4";
import exploremv from "/assets/videos/explore.mp4";
import boxmv from "/assets/videos/box2.mp4";
import filmv from "/assets/videos/fil.mp4";

import icon from "/assets/images/icon.png";
import search from "/assets/images/search.svg";
import buy from "/assets/images/buy.svg";
import watch from "/assets/images/watch.svg";
import right from "/assets/images/right.svg";
import replay from "/assets/images/replay.svg";
import play from "/assets/images/play.svg";
import pause from "/assets/images/pause.svg";

import blue from "/assets/images/blue.png";
import green from "/assets/images/green.png";
import orange from "/assets/images/orange.png";
import red from "/assets/images/red.png";
import turquoise from "/assets/images/turquoise.png";
import yellow from "/assets/images/yellow.png"
import explore1 from "/assets/images/explore1.jpg";
import explore2 from "/assets/images/explore2.jpg";
import explore3 from "/assets/images/explore3.jpg";
import explore4 from "/assets/images/explore4.jpg";
import boxPhoto from "/assets/images/boxPhoto.jpg";
import frame from "/assets/images/frame.png";

import filgreen from "/assets/images/fil-green.jpeg";
import filgreens from "/assets/images/fil-green2.jpeg";
import filyell from "/assets/images/fil-yellow.jpeg";
import filyells from "/assets/images/fil-yellow2.jpeg";
import filblack from "/assets/images/fil-black.jpeg";
import filblacks from "/assets/images/fil-black2.jpeg";

import des1 from "/assets/videos/des1.gif";
import des2 from "/assets/images/des2.gif";
import des3 from "/assets/images/des3.gif";
import des4 from "/assets/images/des4.gif";
import cults from "/assets/images/cults.svg";
import thangs from "/assets/images/thangs.svg";
import bambu from "/assets/images/bambu.svg";
import creality from "/assets/images/creality.svg";

import bambulab1 from "/assets/images/bambulab-p1s.png";
import prusa1 from "/assets/images/prusa1.png";
import prusa2 from "/assets/images/prusa2.png";
import prusa3 from "/assets/images/prusa3.png";
import boat1 from "/assets/images/boat1.png";
import bambulab2 from "/assets/videos/bambulab2.mp4";

import slicerl from "/assets/images/slicer-logo.png";

export const canonVideo = hmv;
export const smallCanonVideo = smallmv;
export const highlightFirstVideo = highlightFirstmv;
export const highlightSecondVideo = highlightSectmv;
export const highlightThirdVideo = highlightThirdmv;
export const highlightFourthVideo = highlightFourthmv;
export const highlightFifthVideo = highlightFifthmv;
export const highlightSixthVideo = highlightSixthmv;
export const exploreVideo = exploremv;
export const boxVideo = boxmv;
export const filVideo=filmv;

export const iconImg = icon;
export const searchImg = search;
export const buyImg = buy;
export const watchImg = watch;
export const rightImg = right;
export const replayImg = replay;
export const playImg = play;
export const pauseImg = pause;

export const blueImg = blue;
export const greenImg = green;
export const orangeImg = orange;
export const redImg = red;
export const yellowImg = yellow;
export const turquoiseImg = turquoise;
export const explore1Img = explore1;
export const explore2Img = explore2;
export const explore3Img = explore3;
export const explore4Img = explore4;
export const boxImg = boxPhoto;
export const frameImg = frame;

export const filgr=filgreen;
export const filgrs=filgreens;
export const filye=filyell;
export const filyes=filyells;
export const filbl=filblack;
export const filbls=filblacks;

export const desOne=des1;
export const desTwo=des2;
export const desThree=des3;
export const desFour=des4;
export const cultsLogo=cults;
export const thangsLogo=thangs;
export const bambuLogo=bambu;
export const crealityLogo=creality;

export const bambOne=bambulab1;
export const prusaOne=prusa1;
export const prusaTwo=prusa2;
export const prusaThree=prusa3;
export const boatOne=boat1;
export const bambTwo=bambulab2;

export const slc=slicerl;